import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  "pk_test_51Pq7bsRoJaQLmYqd4qRazeoMrALjBU3M651qJPFbBhdKblJE91tbFYgv79bRw0kL6euBYmPctBGKyB9O4zXh6bbJ005Y48ahyS"
);

export const generateID = (length) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  for (let i = 0; i < length; i++) {
    result += chars[randomValues[i] % chars.length];
  }
  return result;
};

export const getReadableTimestamp = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};

const getBackendUrl = () => {
  const host = window.location.hostname;

  if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return "http://localhost:5000";
  } else if (host.includes("dev")) {
    return "https://dev.queryloop.ai";
  } else if (host.includes("stage")) {
    return "https://stage.queryloop.ai";
  } else if (host.includes("app")) {
    return "https://app.queryloop.ai";
  } else if (host.includes("beta")) {
    return "https://beta.queryloop.ai";
  } else if (host.includes("lft")) {
    return "https://lft.queryloop.ai";
  } else {
    return "https://app.queryloop.ai";
  }
};

export const BACKEND_URL = getBackendUrl();
